// extracted by mini-css-extract-plugin
module.exports = {"container":"TeamsTile_container__39Z4j","logo":"TeamsTile_logo__AfDK2"};